import React from "react";
import {
    Container, Col, Form,
    FormGroup, Label, Input,
    Button,
} from 'reactstrap';
import "./Auth.css";
import rest from './restService';
import {useHistory} from "react-router";

function Auth() {
    let password;
    let username;
    let history = useHistory();
    let submitForm = function (e) {
        let api = new rest();
        api.Auth(username, password, (data) => {
            localStorage.setItem('access-token', String(data).replace('"', '').replace('"', ''));
            history.push("/");
        }, (e) => {
            console.log(e);
        });
    };

    let onChangePass = function (e) {
        password = e.target.value;
    };

    let onChangeUsr = function (e) {
        username = e.target.value;
    };

    return (
        <div className="Back">
            <Container className="Auth">
                <h2>Вхід</h2>
                <Form className="form" onSubmit={(e) => submitForm(e)}>
                    <Col>
                        <FormGroup>
                            <Label>Ім'я</Label>
                            <Input
                                type="text"
                                name="username"
                                id="usernameId"
                                placeholder="Логин"
                                onChange={(e) => onChangeUsr(e)}
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label for="passwordId">Пароль</Label>
                            <Input
                                type="password"
                                name="password"
                                id="passwordId"
                                placeholder="********"
                                onChange={(e) => onChangePass(e)}
                            />
                        </FormGroup>
                    </Col>
                    <Button color="success"
                            onClick={(e) => submitForm(e)}
                    >Відправити</Button>
                </Form>
            </Container>
        </div>
    )
}

export default Auth;